import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 2,
}));

export const Label = styled("label")(() => ({
  color: "#308CDB",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "0.875rem",
  lineHeight: "24px",
  marginBottom: 0,
}));

interface StringsTextProps {
  isEmpty?: boolean;
}
export const Text = styled("span")(({ isEmpty }: StringsTextProps) => ({
  color: isEmpty ? "#9CA6AF" : "#465869",
  fontWeight: isEmpty ? 400 : 600,
  fontSize: "0.875rem",
  fontFamily: "Manrope",
  lineHeight: "24px",
}));
